<template>
  <div class="parent" v-if="!loading">
    <v-card class="top-row py-2 px-3 mb-2" elevation="2">
      <div style="250px">
        <v-text-field
          class="search-field mr-2"
          label="Sök efter art"
          prepend-inner-icon="mdi-magnify"
          clearable
          outlined
          dense
          hide-details="true"
          @input="onSearch"
        ></v-text-field>
      </div>
      <v-btn size="large" color="primary" :to="{ name: 'ArtCreate' }"> Skapa ny art </v-btn>
    </v-card>
    <v-card class="top-row py-2 px-3" elevation="2">
      <v-chip-group column>
        <v-chip
          v-for="group in artGroups"
          :key="group.id"
          :value="group.value"
          :outlined="!group.value"
          :text-color="group.value ? 'white' : 'default'"
          :color="group.value ? 'green lighten-1' : 'default'"
          @click="onGroupFilter({ ...group })"
        >
          <v-avatar left class="mx-1">
            <span class="overline">{{ group.count }}</span>
          </v-avatar>
          {{ group.name_sve }}
        </v-chip>
      </v-chip-group>

      <!-- <v-btn size="large" color="primary" :to="{ name: 'createImage' }"> Lägg till bild </v-btn> -->
    </v-card>
    <div class="list mt-3">
      <ArtCard v-for="art in arter" :key="art.id" v-bind="art" />
    </div>
    <router-view />
  </div>
</template>

<script>
import ArtCard from '@/components/livet/ArtCard'
import { ArtGroups } from '@/assets/data/options'

let debounce = null

export default {
  name: 'ArterList',
  props: {
    arter: { type: Array, default: () => [] },
    allArter: { type: Array, default: () => [] },
    loading: { type: Boolean },
    meta: { type: Object },
  },
  components: {
    ArtCard,
  },
  data() {
    return {
      artGroups: ArtGroups.map((g) => {
        if (g.id === 0) {
          return {
            ...g,
            value: true,
            count: this.allArter.length,
          }
        }
        return {
          ...g,
          value: false,
          count: this.allArter.filter((a) => a.life_cat_id === g.id).length,
        }
      }),
    }
  },
  computed: {},
  methods: {
    onGroupFilter({ id }) {
      this.artGroups.map((g) => (g.value = false))
      this.artGroups.find((g) => g.id === id).value = true
      if (id === 0) {
        this.$emit('filter', [])
        return
      }
      const omitGroups = this.artGroups.filter(({ value }) => !value).map(({ id }) => id)
      this.$emit('filter', omitGroups)
    },
    onSearch(val) {
      clearTimeout(debounce)
      debounce = setTimeout(() => {
        this.$emit('search', val)
      }, 600)
    },
  },
}
</script>

<style lang="less" scoped>
.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list {
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-column-gap: 15px;
  grid-row-gap: 15px;
}
</style>
